<template>
  <div id="Special-Offer">
    <section v-if="!$route.params.id" class="special-offer bg-white">
      <div
        ref="wrap"
        class="row position-relative"
        v-masonry
        transition-duration="0"
        item-selector=".item"
        column-width=".item"
      >
        <div
          class="col-md-6 col-xl-4 item"
          v-for="(item, index) in coupon"
          :key="index"
          v-masonry-tile
          data-aos="fade-up"
          data-aos-easing="ease-out-back"
          data-aos-delay="50*index"
          data-aos-duration="800"
          data-aos-anchor-placement="top-bottom"
        >
          <div class="card">
            <router-link :to="{name:'Coupon', params:{id:item.uuid}}">
              <div
                class="card-img-top"
                v-lazy:background-image="{src: item.media.data.length>0 && item.media.data[0].medium, error: require('@/assets/image/demo-coupon.jpg')}"
              >
                <div
                  class="badge text-white"
                  :style="{'background-color': item.stores.data.length>0 && item.stores.data[0].color !== '' ? item.stores.data[0].color : '#fa6400'}"
                >
                  <span>{{item.brand_name}}</span>
                </div>
              </div>
              <div class="card-body p-15">
                <div class="form-row">
                  <div class="col-12">
                    <div class="card-title m-0">
                      <h6 class="title m-0">{{item.title}}</h6>
                      <p class="desc m-0">{{item.subtitle}}</p>
                    </div>
                  </div>
                </div>
                <div class="card-text d-flex align-items-center justify-content-start mt-20">
                  <Icons name="product" color="#eec273" />
                  <p class="h5 m-0 ml-10 font-weight-bolder">{{item.point}}</p>
                  <p class="m-0 ml-auto">
                    <small>
                      <span class="d-md-none d-lg-inline">有效期限</span>
                      {{item.expire_at | date}}
                    </small>
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        <div class="col-12 loading d-flex align-items-center justify-content-center" ref="loading">
          <img
            src="/img/spinner.svg"
            alt="loading"
            width="200"
            height="200"
            :class="{'d-none': page>=total_pages}"
          />
        </div>
      </div>
    </section>
    <router-view
      v-else
      @sendTitle="sendTitle"
      data-aos="fade-up"
      data-aos-easing="ease-out-back"
      data-aos-delay="50"
      data-aos-duration="700"
    ></router-view>
  </div>
</template>

<script>
import Icons from '@/components/icon.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Special-Offer',
  metaInfo: {
    title: '會員專屬優惠 | ',
  },
  components: {
    Icons,
  },
  data() {
    return {
      coupon: [],
      pagination: {},
      page: 1,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['screenWidth', 'scrollY', 'wrapH']),
    total_pages() {
      return this.pagination.total_pages;
    },
  },
  methods: {
    ...mapActions(['update_width', 'update_scroll', 'update_H']),
    sendTitle(title) {
      this.$emit('sendTitle', title);
    },
    getCoupon() {
      const url = '/coupon';
      const params = {
        limit: 9,
        page: this.page,
      };
      this.axios
        .get(url, { params })
        .then((response) => {
          this.coupon = [...this.coupon, ...response.data.data];
          this.pagination = response.data.meta.pagination;
          this.loading = false;
        })
        .catch((error) => {
          this.$toasted.global.error({ message: error.response.data.message });
          this.loading = false;
        });
    },
  },
  mounted() {
    this.getCoupon();
  },
  watch: {
    scrollY(value) {
      const rangeTo = value - this.wrapH;
      if (!this.loading && rangeTo > -200 && rangeTo < 300) {
        if (this.total_pages > this.page) {
          this.page += 1;
        }
      }
    },
    page(value) {
      this.loading = true;
      if (value) {
        // setTimeout(() => {
        //   this.getCoupon();
        // }, 50);
        this.$nextTick(() => {
          this.getCoupon();
        });
      }
    },
    $route() {
      this.page = 1;
      this.coupon = [];
      this.getCoupon();
    },
  },
};
</script>
<style lang="scss" scoped>
#Special-Offer {
  .special-offer {
    padding: 20px 0 100px;
    .item {
      .card {
        margin-bottom: 25px;
        border: none;
        a {
          color: unset;
        }
        .card-img-top {
          position: relative;
          height: 400px;
          background-position: center center;
          background-size: cover;
          background-repeat: no-repeat;
          .badge {
            position: absolute;
            bottom: 10px;
            right: 10px;
          }
        }
        .card-body {
          p,
          h6,
          span,
          small {
            letter-spacing: normal;
          }
        }
      }
      &:nth-child(even) {
        .card {
          background: linear-gradient(to right, #ffffff -33%, #d1d1d1);
          .card-img-top {
            height: 390px;
          }
        }
      }
      &:nth-child(odd) {
        .card {
          background: linear-gradient(to right, #b7c5e4 -47%, #41495a 63%, $secondary-dark 100%);
          color: white;
          .card-img-top {
            height: 410px;
          }
        }
      }
    }
    .loading {
      position: absolute;
      bottom: 0;
      left: 0;
      bottom: -150px;
    }
  }
}
</style>
